<ng-template #exportScoresModal let-modal>
  <div class="modal-header border-bottom-0">
    <h5 class="modal-title">{{ 'EXPORT.SCORES.TITLE' | translate }}</h5>
    <div id="closeModal">
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click');">
        <span aria-hidden="true">&times;</span>&nbsp;
        <span>{{ 'COMMON.CLOSE' | translate }}</span>
      </button>
    </div>
  </div>

  <div class="modal-body">
    <div class="container my-3">

      <div *ngIf="!showSpinner" class="form-group">
        <div class="row">
          <div class="col-12">
            <div class="alert alert-warning" role="alert" [innerHtml]="'EXPORT.SCORES.INSTRUCTIONS' | translate" *ngIf="currentConsultant.raas.nameid"></div>
            <div class="alert alert-warning" role="alert" [innerHtml]="'EXPORT.SCORES.INSTRUCTIONS_EMAIL' | translate" *ngIf="!currentConsultant.raas.nameid"></div>
          </div>
        </div>
      </div>

      <div *ngIf="showSpinner" class="form-group">
        <div class="row justify-content-center">
          <div class="loading-overlay-spinner"></div>
        </div>
        <p class="text-center mt-3"> {{'EXPORT.SCORES.PHRASE' | translate }} </p>
      </div>

      <hr class="my-4">

      <ng-container *ngIf="!showSpinner">
        <button type="button" class="btn btn-light mr-3" (click)="modal.dismiss('cancel click')">
          {{ 'COMMON.CANCEL' | translate }}
        </button>
        <button type="button" class="btn btn-primary" (click)="confirmShowSpinner()">
          {{ 'COMMON.CONFIRM' | translate }}
        </button>
      </ng-container>

    </div>
  </div>
</ng-template>
